import { useContext, useState, useRef, useEffect } from "react"
import { useIdleTimer } from "react-idle-timer"
import { TimerState, useMenuStore } from "../store/menuState";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useOrderStore } from "../store/order";
import { useInfoStore } from "../store/userInfo";
import { Axios } from "../api/axios";
import { logger } from "../utils/logger";

const useIdleTimeout = ({idleTime = 60, disableIdleTimer}: {idleTime?: number, disableIdleTimer: boolean}) => {
    const navigate: NavigateFunction = useNavigate();
    const { orderBook, userInfo, tableInfo } = useInfoStore()
    const { isIdle, timerState, totalOrderTimeLimit, setIsIdle, setIsPromotion, resetPopup, setPromotionList, setIdleState, setItemDetail, setSelectedItem } = useMenuStore();
    const { totalCount, resetOrderCart, setOpenCart } = useOrderStore();
    const storeId = userInfo?.storeId;
    const isKiosk = tableInfo.isKioskMode;
    const timerRef = useRef<NodeJS.Timeout>();

    const idleTimeout = !orderBook ? isKiosk ? 15000 * 60: 1000 * 60 : 30000 * 60;
    
    const handleIdle = async () => {
      logger.log('handleIdle', timerState)

      // if(totalOrderTimeLimit.useAyceTimeLimit && timerState === TimerState.FINISHED) {
      //   setIsIdle(false);
      //   return
      // }
      if(!isKiosk && totalCount) {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
          setOpenCart(true)
        }, 300);
        logger.log('idle')
        resetPopup()
        setIsIdle(false);
        setIdleState(true)
      } else {
        try {
          logger.log('Starting promotion activation...');
          // 프로모션 상태 초기화
          setIsPromotion(false);
          setPromotionList(-1);
          
          // 프로모션 데이터 새로 가져오기
          const response = await Axios({
            method: 'GET',
            url: `advertisements/promotions/stores/${storeId}`,
          });
          
          logger.log('Promo list:', response.data);
          if(response.data && Array.isArray(response.data) && response.data.length > 0) {
            setPromotionList(response.data.length);
            // 프로모션 활성화
            setIsIdle(true);
            setIsPromotion(true);
            setItemDetail(null);
            setSelectedItem(null);
            resetOrderCart();
            resetPopup();
            logger.log('Promotion activated successfully');
          } else {
            logger.log('No promotions available, showing default promotion');
            // 프로모션 데이터가 없어도 기본 프로모션 이미지로 프로모션 실행
            setPromotionList(0); // 기본 프로모션을 위해 0으로 설정
            setIsIdle(true);
            setIsPromotion(true);
            setItemDetail(null);
            setSelectedItem(null);
            resetOrderCart();
            resetPopup();
            logger.log('Default promotion activated');
          }
        } catch (error) {
          logger.error('Failed to fetch promotions:', error);
          setIsIdle(false);
          setIsPromotion(false);
        }
      }
    }

    // Cleanup on unmount
    useEffect(() => {
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };
    }, []);

    const idleTimer = useIdleTimer({
        timeout: idleTimeout,
        disabled: disableIdleTimer,
        onIdle: handleIdle,
        debounce: 1000
    })

    return {
        isIdle,
        setIsIdle,
        idleTimer
    }
}
export default useIdleTimeout;